import { render, staticRenderFns } from "./TheEventPackageOffer.vue?vue&type=template&id=3b424e9e&scoped=true&"
import script from "./TheEventPackageOffer.vue?vue&type=script&lang=js&"
export * from "./TheEventPackageOffer.vue?vue&type=script&lang=js&"
import style0 from "./TheEventPackageOffer.vue?vue&type=style&index=0&id=3b424e9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b424e9e",
  null
  
)

export default component.exports